import { render, staticRenderFns } from "./TaskDescription.vue?vue&type=template&id=174e2b0e&scoped=true&"
import script from "./TaskDescription.vue?vue&type=script&lang=ts&"
export * from "./TaskDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174e2b0e",
  null
  
)

export default component.exports